@import '~less/global-variables';
@import '~less/layout/typography';
@import '~less/bootstrap/legacy-mixins';

/**
 * Home page
 */

// Section - intro
.home-intro {
  text-align: center;
  padding: 0;
}

// Upmost element at intro section
.home-logo {
  margin-bottom: 40px;
  margin-top: 30px;
}
// Downmost element at intro section
.home-down {
  font-size: 35px;
  opacity: 0.8;
  margin: 30px 0 0 0;
}
.home-tagline {
  margin: 0 auto;
}
.home-join {
  margin-top: 40px;
}
.home-tagline {
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.6);
}
.home-tagline {
  color: #fff;
  padding: 0;
  font-size: 45px;
  line-height: 50px;
  .font-brand-semibold();
}
.home-subtagline {
  font-size: 30px;
  line-height: 40px;
}

// App Store / Play Store buttons
.home-apps {
  margin-top: 25px;
  .btn {
    @media (max-width: @screen-sm-max) {
      .button-size(@padding-base-vertical; @padding-base-horizontal; @font-size-base; @line-height-base; @btn-border-radius-base);
    }
    margin: 0 5px;
  }
}

// Note `max-height` here instead of max-width
@media screen and (max-height: 700px) {
  .home-logo,
  .home-tagline {
    margin: 15px auto;
  }
  .home-logo {
    max-width: 170px;
    max-height: 170px;
  }
  .home-tagline {
    font-size: 32px;
    line-height: 40px;
  }
  .home-subtagline {
    font-size: 28px;
    line-height: 38px;
  }
}
@media (max-width: @screen-sm-max) {
  .home-subtagline {
    font-size: 25px;
    line-height: 35px;
  }
}
@media (max-width: @screen-xs-max) {
  .home-tagline {
    font-size: 22px;
    line-height: 28px;
    text-shadow: none;
  }
  .home-subtagline {
    font-size: 20px;
    line-height: 29px;
    text-shadow: none;
  }
}

// Home section - hospex & how
.home-how {
  background: #fff;
  padding: 80px 0 50px;
  @media (max-width: @screen-sm-max) {
    padding: 80px 0 10px 0;
  }
  .icon-sofa::before {
    width: 2em;
  }

  // Tribe bubbles for small screens
  .tribes-xs {
    text-align: center;
    margin: 0 -10px 30px 0;
  }
  .tribe-xs {
    display: inline-block;
    .square(100px);
    line-height: 100px;
    .font-brand-light();
    font-size: 60px;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    user-select: none;
    margin: 0 0 0 -20px; // To overlap bubbles with each other
    &:first-child {
      margin-left: 10px; // Half of the minus margin of `.tribe-xs`
    }
    &,
    &:hover {
      text-decoration: none;
    }
  }
  .tribe,
  .tribe-intro {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    width: 100%;
    @media (min-width: @screen-sm-min) {
      .square(150px);
    }
    @media (min-width: @screen-md-min) {
      .square(220px);
    }
    @media (min-width: @screen-lg-min) {
      .square(260px);
    }
  }
  .tribe-intro {
    text-align: center;
    height: auto;
    p {
      padding: 0;
      margin: 0;
      font-size: 16px;
    }
    h2 {
      font-size: 23px;
    }
    @media (min-width: @screen-md-min) {
      p {
        font-size: 21px;
      }
      h2 {
        font-size: 26px;
      }
    }
    @media (max-width: @screen-md-max) {
    }
  }
  .tribe {
    overflow: hidden;
    .tribe-link {
      display: block;
      position: relative;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.65) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      .tribe-label {
        word-wrap: break-word;
        position: absolute;
        left: 43px;
        right: 43px;
        bottom: 35px;
        padding: 0;
        margin: 0;
        text-align: center;
        @media (max-width: @screen-sm-max) {
          left: 25px;
          right: 25px;
          bottom: 25px;
          font-size: @font-size-base;
        }
      }
    }
  }
}

.home-wohoo {
  width: 207px;
  height: 162px;
  .img-retina('~img/wohoo.png', '~img/wohoo@2x.png', 207px, 162px);
}

// Home section - footer
.home-footer {
  margin-bottom: -@article-padding-bottom;
  @media (max-width: @screen-xs-max) {
    margin-bottom: -@article-padding-bottom-xs;
  }
  background-position: 50% bottom;
  padding-top: 30px;
  text-shadow: none;
  .boards-credits {
    display: block;
    padding: 30px;
    a {
      text-decoration: none;
    }
    // On bigger screens:
    // Make credits slightly opaque and add hover effects
    @media (min-width: @screen-md-min) {
      opacity: 0.5;
      a:hover {
        border-bottom: 1px solid #fff;
      }
      &:hover {
        transition: opacity 0.3s linear;
        opacity: 1;
      }
    }
    @media (max-width: @screen-sm-max) {
      font-size: 13px;
      a {
        border-bottom: 1px solid #fff;
      }
    }
  }
}

.home-footer-some {
  margin: 40px 0;
  font-size: 20px;
}

.home-footer-join {
  margin: 80px 0;
}

// This requires `a` and `:not(.btn)` due they are defined for `.board a {}` at core-module's `layout/board.less`
a.home-footer-more:not(.btn) {
  text-decoration: none;
}

.home-footer-pages {
  font-size: 20px;
  line-height: 40px;
  a:not(.btn) {
    text-decoration: none;
    &:hover {
      border-bottom: 1px solid #fff;
    }
  }
  &:before {
    display: block;
    width: 40%;
    height: 1px;
    background: #fff;
    content: '';
    margin: 27px 0 18px 0;
    @media (max-width: @screen-sm-max) {
      width: 100%;
    }
  }
}
